import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { dismissFraudIndicatorRequest } from '../../../../store/entities/entities.actions';

import type { FraudIndicator } from '../../../../types/fraud-detection';

export const useDismissFraudIndicator = () => {
  const dispatch = useDispatch();

  const dismissIndicator = useCallback(
    (fulfillmentPlanId: string, fraudIndicatorCode: string, originalIndicator: FraudIndicator) => {
      dispatch(dismissFraudIndicatorRequest(fulfillmentPlanId, fraudIndicatorCode, originalIndicator));
    },
    [dispatch],
  );

  return { dismissIndicator };
};
